export class BaseRepository {
  constructor() {
    this.ajaxUrl = '/wp-admin/admin-ajax.php';
  }

  getFormData(data) {
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }

    return formData;
  }

  async post(data) {
    try {
      let axios = await import('axios' /*webpackChunkName: "axios" */);
      return new Promise((resolve, reject) => {
        axios.default({
          method: 'post',
          url: this.ajaxUrl,
          data: this.getFormData(data),
          headers: {'Content-Type': 'multipart/form-data'}
        }).then((response) => {
          resolve(response.data);
        }, (error) => {
          resolve(null);
        });
      });
    } catch (error) {
      console.error('Error importing axios:', error);
      return null;
    }
  }

  async postWithFormData(formData) {
    try {
      let axios = await import('axios' /*webpackChunkName: "axios" */);
      return new Promise((resolve, reject) => {
        axios.default({
          method: 'post',
          url: this.ajaxUrl,
          data: formData,
          headers: {'Content-Type': 'multipart/form-data'}
        }).then((response) => {
          resolve(response.data);
        }, (error) => {
          resolve(null);
        });
      });
    } catch (error) {
      console.error('Error importing axios:', error);
      return null;
    }
  }
}